var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUbuntuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_182_1",
    "data-name": "Component 182 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 74,
    height: 75,
    rx: 6,
    fill: "#ff5722"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(-676.21 -199.796)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 5.896,
    cy: 5.896,
    r: 5.896,
    transform: "translate(682.916 231.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 5.896,
    cy: 5.896,
    r: 5.896,
    transform: "translate(721.823 253.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 5.896,
    cy: 5.896,
    r: 5.896,
    transform: "translate(721.823 208.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M221.942,54.339a1.179,1.179,0,0,0,1.309.554A11.724,11.724,0,0,1,237.467,63.1a1.179,1.179,0,0,0,1.134.858h9.637a1.179,1.179,0,0,0,1.18-1.179,1.2,1.2,0,0,0-.015-.187,23.523,23.523,0,0,0-5.363-11.606,1.179,1.179,0,0,0-1.547-.207,8.247,8.247,0,0,1-12.823-6.755,1.179,1.179,0,0,0-1.054-1.156A23.656,23.656,0,0,0,217.708,44.3a1.179,1.179,0,0,0-.6,1.691Z",
    transform: "translate(489.801 170.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M248.358,277.333h-9.637a1.179,1.179,0,0,0-1.134.858,11.719,11.719,0,0,1-14.217,8.205,1.179,1.179,0,0,0-1.309.554l-4.821,8.351a1.179,1.179,0,0,0,.6,1.691,23.289,23.289,0,0,0,10.908,1.429,1.179,1.179,0,0,0,1.054-1.156,8.236,8.236,0,0,1,12.809-6.755,1.179,1.179,0,0,0,1.549-.215,23.522,23.522,0,0,0,5.363-11.6,1.179,1.179,0,0,0-.978-1.351A1.2,1.2,0,0,0,248.358,277.333Z",
    transform: "translate(489.684 -37.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M111.686,114.979a11.769,11.769,0,0,1,0-16.422,1.179,1.179,0,0,0,.175-1.415l-4.814-8.332a1.179,1.179,0,0,0-.809-.571,1.231,1.231,0,0,0-.958.236,23.6,23.6,0,0,0-7.434,10.648,1.179,1.179,0,0,0,.366,1.295,8.125,8.125,0,0,1,0,12.7,1.179,1.179,0,0,0-.366,1.295,23.6,23.6,0,0,0,7.431,10.639,1.179,1.179,0,0,0,.745.264,1.291,1.291,0,0,0,.212-.019,1.179,1.179,0,0,0,.809-.571l4.814-8.337A1.179,1.179,0,0,0,111.686,114.979Z",
    transform: "translate(595.795 130.527)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbuntuLogo);
export default __webpack_public_path__ + "static/media/ubuntu-logo.e0235f7f8cf4a34927cfb38151c36bc7.svg";
export { ForwardRef as ReactComponent };